import { useEffect, useState, useContext, useCallback } from 'react'
import {
  MediaLibraryActions,
  MediaLibraryActionType,
} from '../providers/MLProvider'
import { MLContext } from '../providers'
interface Options {
  type: 'folder' | 'file' | 'mediaCollection'
  dispatch: React.Dispatch<
    MediaLibraryActionType | MediaLibraryActionType[]
  >
}

function useKeyboardSelection({ type = 'file', dispatch }: Options) {
  const [index, setIndex] = useState({
    startIndex: -1,
    endIndex: -1,
  })

  const [{ mediaCollectionList }] = useContext(MLContext)

  const onSelect = useCallback(
    (idx, shiftKeyPressed) => {
      setIndex(prev =>
        prev.startIndex !== -1 && prev.endIndex === -1 && shiftKeyPressed
          ? { ...prev, endIndex: idx + 1 }
          : { startIndex: idx, endIndex: -1 },
      )
    },
    [setIndex],
  )
  useEffect(() => {
    if (index.startIndex !== -1 && index.endIndex !== -1) {
      let start = index.startIndex
      let end = index.endIndex
      if (index.startIndex >= index.endIndex) {
        start = index.endIndex - 1
        end = index.startIndex + 1
      }

      if (type === 'file') {
        dispatch({
          type: MediaLibraryActions.SELECT_FILE_WITH_SHIFT,
          payload: { start, end },
        })
      }
      if (type === 'mediaCollection') {
        const selectedItems = mediaCollectionList.slice(start, end)

        dispatch({
          type: MediaLibraryActions.SET_SELECTED_MEDIA_COLLECTIONS,
          payload: selectedItems,
        })
      }
      if (type === 'folder') {
        dispatch({
          type: MediaLibraryActions.SELECT_FOLDER_WITH_SHIFT,
          payload: { start, end },
        })
      }
    }
  }, [index.startIndex, index.endIndex, type, mediaCollectionList])

  return { onSelect }
}

export default useKeyboardSelection
